import React from 'react';
import { useTranslation } from 'react-i18next';

import { Text } from '@/nova/components';

import { useConfigurator } from '../../../../store/configurator';
import { Chip, ChipCode, ChipRemove } from './VoucherChip.styles';

export type VoucherChipProps = {
  /** The applied voucher code to display. */
  code: string;
};

/**
 * The applied-voucher chip shown in the billing summary's "Discount Voucher" row: the code as a
 * monospaced pill with a trailing × that removes it (clears the session's `voucher_code`). Self-wired
 * via {@link useConfigurator}; the discount line + total update reactively once the remove lands.
 */
export const VoucherChip = ({ code }: VoucherChipProps): React.ReactElement => {
  const { t } = useTranslation();
  const { removeVoucher, voucherPending } = useConfigurator();
  return (
    <Chip>
      <ChipCode text={code} tag="span" />
      <ChipRemove
        type="button"
        onClick={() => {
          if (!voucherPending) void removeVoucher();
        }}
        disabled={voucherPending}
        aria-label={t('Remove voucher')}
      >
        <svg width="10" height="10" viewBox="0 0 10 10" aria-hidden="true" focusable="false">
          <path d="M1 1L9 9M9 1L1 9" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        </svg>
      </ChipRemove>
    </Chip>
  );
};

export default VoucherChip;
